module.exports = __webpack_public_path__ + "img/uavfly-operator.46f23609.png";